import React, { useState, useRef } from 'react';

const ImagesTab = (props) => {
    const [uploadedImage, setUploadedImage] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef(null);
    
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            
            // Make sure it's an image
            if (!file.type.match('image.*')) {
                alert('Please select an image file');
                return;
            }
            
            // Create preview URL
            const reader = new FileReader();
            reader.onload = (event) => {
                setUploadedImage({
                    name: file.name,
                    type: 'image',
                    fileUrl: event.target.result,
                    isUpload: true,
                    file: file,
                    assetID: 'new-upload-' + Date.now() // Temporary ID
                });
                
                // Automatically select this image
                props.onSelect({
                    name: file.name,
                    type: 'image',
                    fileUrl: event.target.result,
                    isUpload: true,
                    file: file,
                    assetID: 'new-upload-' + Date.now() // Temporary ID
                });
            };
            reader.readAsDataURL(file);
        }
    };
    
    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    
    const handleDrop = (e) => {
        e.preventDefault();
        
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            
            // Make sure it's an image
            if (!file.type.match('image.*')) {
                alert('Please drop an image file');
                return;
            }
            
            // Create preview URL
            const reader = new FileReader();
            reader.onload = (event) => {
                setUploadedImage({
                    name: file.name,
                    type: 'image',
                    fileUrl: event.target.result,
                    isUpload: true,
                    file: file,
                    assetID: 'new-upload-' + Date.now() // Temporary ID
                });
                
                // Automatically select this image
                props.onSelect({
                    name: file.name,
                    type: 'image',
                    fileUrl: event.target.result,
                    isUpload: true,
                    file: file,
                    assetID: 'new-upload-' + Date.now() // Temporary ID
                });
            };
            reader.readAsDataURL(file);
        }
    };
    
    const handleDragOver = (e) => {
        e.preventDefault();
    };
    
    // Combine event and misc assets
    const renderEventAssets = () => {
        if (!props.eventAssets || props.eventAssets.length === 0) {
            return (
                <div className="alert alert-info">
                    <p>{props.searchTerm ? 'No image assets match your search.' : 'No image assets available in this event.'}</p>
                </div>
            );
        }
        
        return (
            <div className="image-grid">
                {props.eventAssets.map((asset) => (
                    <div 
                        key={asset.assetID} 
                        className={`image-card ${props.selectedItem && props.selectedItem.assetID === asset.assetID ? 'selected' : ''}`}
                        onClick={() => props.onSelect(asset)}
                    >
                        <div className="image-thumbnail">
                            <img 
                                src={asset.fileUrl || '/assets/images/image-placeholder.jpg'} 
                                alt={asset.name} 
                            />
                        </div>
                        <div className="image-details">
                            <h4 title={asset.name}>{asset.name}</h4>
                            <div className="image-source">From: Event</div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };
    
    const renderMiscAssets = () => {
        if (!props.miscAssets || props.miscAssets.length === 0) {
            return (
                <div className="alert alert-info">
                    <p>{props.searchTerm ? 'No image assets match your search.' : 'No image assets available in the media library.'}</p>
                </div>
            );
        }
        
        return (
            <div className="image-grid">
                {props.miscAssets.map((asset) => (
                    <div 
                        key={asset.assetID} 
                        className={`image-card ${props.selectedItem && props.selectedItem.assetID === asset.assetID ? 'selected' : ''}`}
                        onClick={() => props.onSelect(asset)}
                    >
                        <div className="image-thumbnail">
                            <img 
                                src={asset.fileUrl || '/assets/images/image-placeholder.jpg'} 
                                alt={asset.name} 
                            />
                        </div>
                        <div className="image-details">
                            <h4 title={asset.name}>{asset.name}</h4>
                            <div className="image-source">From: Media Library</div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };
    
    return (
        <div className="images-tab">
            <div 
                className="upload-section" 
                onDrop={handleDrop}
                onDragOver={handleDragOver}
            >
                <div className="upload-icon">
                    <i className="fa fa-cloud-upload"></i>
                </div>
                <div className="upload-title">
                    Drag & Drop Image Here
                </div>
                <div className="upload-subtitle">
                    or
                </div>
                <button 
                    className="btn btn-primary btn-upload" 
                    onClick={handleBrowseClick}
                    disabled={isUploading}
                >
                    {isUploading ? (
                        <><i className="fa fa-spinner fa-spin"></i> Uploading...</>
                    ) : (
                        <>Browse for Image</>
                    )}
                </button>
                <input 
                    type="file" 
                    className="hidden" 
                    ref={fileInputRef} 
                    onChange={handleFileChange} 
                    accept="image/*"
                />
            </div>
            
            {uploadedImage && (
                <div className="assets-section">
                    <h3>Uploaded Image</h3>
                    <div className="image-grid">
                        <div 
                            className={`image-card ${props.selectedItem && props.selectedItem.assetID === uploadedImage.assetID ? 'selected' : ''}`}
                            onClick={() => props.onSelect(uploadedImage)}
                        >
                            <div className="image-thumbnail">
                                <img 
                                    src={uploadedImage.fileUrl} 
                                    alt={uploadedImage.name} 
                                />
                            </div>
                            <div className="image-details">
                                <h4 title={uploadedImage.name}>{uploadedImage.name}</h4>
                                <div className="image-source">New Upload</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            <div className="assets-section">
                <h3>Event Images</h3>
                {renderEventAssets()}
            </div>
            
            <div className="assets-section">
                <h3>Media Library Images</h3>
                {renderMiscAssets()}
            </div>
        </div>
    );
};

export default ImagesTab; 